import React from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

export default function AssetDetailsSkeleton({ narrow = false }) {
  return (
    <Box display="flex" flexDirection={narrow ? "column" : "row"} gap={3} p={3}>
      <Box
        sx={{
          minWidth: narrow ? "100%" : 300,
          maxWidth: narrow ? "100%" : 400,
        }}
      >
        <Skeleton variant="rectangular" width="100%" height={400} sx={{ borderRadius: 2 }} />
      </Box>

      <Box flex={1} display="flex" flexDirection="column" gap={3}>
        <Box>
          <Skeleton variant="text" width={120} height={30} sx={{ mb: 2 }} />
          <Box display="flex" gap={2} mb={2}>
            <Skeleton variant="rectangular" width="48%" height={56} sx={{ borderRadius: 1 }} />
            <Skeleton variant="rectangular" width="48%" height={56} sx={{ borderRadius: 1 }} />
          </Box>
          <Box display="flex" gap={2}>
            <Skeleton variant="rectangular" width="48%" height={56} sx={{ borderRadius: 1 }} />
            <Skeleton variant="rectangular" width="48%" height={56} sx={{ borderRadius: 1 }} />
          </Box>
        </Box>

        <Box>
          <Skeleton variant="text" width={120} height={30} sx={{ mb: 2 }} />
          <Box display="flex" gap={2} mb={2}>
            <Skeleton variant="rectangular" width="48%" height={56} sx={{ borderRadius: 1 }} />
            <Skeleton variant="rectangular" width="48%" height={56} sx={{ borderRadius: 1 }} />
          </Box>
          <Skeleton variant="rectangular" width="32%" height={56} sx={{ borderRadius: 1 }} />
        </Box>

        <Box>
          <Skeleton variant="text" width={160} height={30} sx={{ mb: 2 }} />
          <Box display="flex" gap={2} mb={2}>
            <Skeleton variant="rectangular" width="48%" height={56} sx={{ borderRadius: 1 }} />
            <Skeleton variant="rectangular" width="48%" height={56} sx={{ borderRadius: 1 }} />
          </Box>
          <Box display="flex" gap={2}>
            <Skeleton variant="rectangular" width="48%" height={56} sx={{ borderRadius: 1 }} />
            <Skeleton variant="rectangular" width="48%" height={56} sx={{ borderRadius: 1 }} />
          </Box>
        </Box>

        <Box>
          <Skeleton variant="text" width={100} height={30} sx={{ mb: 2 }} />
          <Skeleton variant="rectangular" width="100%" height={56} sx={{ borderRadius: 1 }} />
        </Box>
      </Box>
    </Box>
  );
}
